import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { checkIsAosDevice } from '@repo/utils';

import { checkIsLogin } from 'utils/auth';

import { PATH } from 'routers/paths';

export default function OnlyAndroidDevice({ children }: PropsWithChildren) {
  const isAosDevice = checkIsAosDevice();
  const navigate = useNavigate();

  useEffect(() => {
    // 안드로이드 이외의 기기는 접속 불가능하도록 처리
    const isLogin = checkIsLogin();
    if (isAosDevice) {
      if (isLogin) {
        navigate(PATH.DASHBOARD);
        return;
      } else {
        const redirectURL = window.location.origin + PATH.AUTH.SIGN_IN;
        localStorage.setItem('redirectURL', redirectURL);
      }
    } else {
      if (isLogin) {
        navigate(PATH.DASHBOARD);
        return;
      } else {
        const redirectURL = import.meta.env.VITE_APP_BUBBLECHAT_URL;
        window.location.href = `${redirectURL}/sign-in?callbackUrl=${window.origin}`;
      }
    }
  }, []);

  return <>{children}</>;
}
